import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { setActiveTab, setExplodedViewCount } from '../Actions/ProductInfoTab.action';

class ProductInfoTab extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }

    componentDidMount() {

        const { setExplodedViewCount, explodedViewImgCount } = this.props;
        if (setExplodedViewCount && explodedViewImgCount) {
            setExplodedViewCount(explodedViewImgCount);
        }
    }

    setTab(event) {
        const el = event.target;
        const tabTag = el.parentElement.parentElement;
        const radioTag = tabTag.querySelector('input.tab__checkbox:checked');
        
        let { setActiveTab, tabType } = this.props;
        
        if (setActiveTab && tabType) {
            if (radioTag) {
                tabType = '';
            }
            setActiveTab(tabType);
        }
    }
    
    render() {
        return (
            <Fragment>
                <span onClick={event => { this.setTab(event) }}>{this.props.title} <i className="material-icons fa-chevron-down">expand_more</i><i className="material-icons fa-chevron-up">expand_less</i></span>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        activeInfoTab: state.productInfoTab.activeInfoTab,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setActiveTab: (name) => dispatch(setActiveTab(name)),
        setExplodedViewCount: (count) => dispatch(setExplodedViewCount(count)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfoTab);